import { Lerd } from "./Lerd";

export default Lerd;